/**
 * Where the API lives, worked out from where the page is.
 *
 * There were nine copies of these four lines before this file existed. It moved
 * here when the webhook slice needed the answer somewhere other than a gateway:
 * a member has to be shown the address their own system will post to, and an
 * address the product prints must be the same one it would call itself.
 */
export function inferApiBase() {
  if (typeof window === 'undefined') return 'http://localhost:3001';
  const host = window.location?.hostname || 'localhost';
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  return isLocal ? `http://${host}:3001` : 'https://api.agilepro.ai';
}
